import { variant } from 'styled-system';

const createSemanticType = (type) => {
  return {
    backgroundColor: `${type}.20`,
    color: `${type}.90`,
  };
};

const softTypeVariant = () =>
  variant({
    prop: 'type',
    variants: {
      positive: createSemanticType('positive'),
      informative: createSemanticType('info'),
      warning: createSemanticType('warning'),
      critical: createSemanticType('critical'),
      neutral: {
        backgroundColor: 'neutral.30',
        color: 'neutral.90',
      },
    },
  });

export default softTypeVariant;
